"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import type { ClassNameProp } from "../../props";
import { profileStyle } from "./DataCard.css";
import { Card } from "../Card/Card";
import { Text } from "../Text/Text";
import { Flex } from "../Flex/Flex";
import { Avatar } from "../Avatar/Avatar";
import { InputList } from "../InputList/InputList";
import type { UserRecord } from "../../types";

export type DataCardProps = HTMLAttributes<HTMLDivElement | HTMLButtonElement> &
  ClassNameProp & {
    title?: string;
    /**
     * @deprecated Use `user` instead.
     */
    name?: string;
    user?: UserRecord;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement | HTMLButtonElement>;
  };

/**
 * A card component that displays a title and a list of items.
 * @deprecated
 */
export const DataCard: FC<DataCardProps> = ({
  title,
  name,
  user,
  className,
  children,
  ref,
  ...props
}) => (
  <Card
    ref={ref as Ref<HTMLDivElement>}
    className={mergeClasses(className)}
    variant="primary"
    border="default"
    {...props}
  >
    <Flex className={profileStyle} align="center">
      {(user || name) && (
        <Avatar
          id={user?.id}
          value={user?.name || name}
          image={user?.image}
          variant="secondary"
        />
      )}
      <Text variant="bodyL" as="h3">
        {title ?? name}
      </Text>
    </Flex>
    <InputList>{children}</InputList>
  </Card>
);
